<template>
  <vs-row vs-w="12">
    <vs-col vs-w="12">

      <vs-row vs-w="12">
        <vs-input type="number" label="Score per unused seat multiplier:" max="-1" v-model="seatingStrategy.scorePerUnusedSeatMultiplier" />
      </vs-row>
    </vs-col>

  </vs-row>
</template>

<script>
export default {
  components: {
  },
  props: {
    seatingStrategy: Object,
  },
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
};
</script>
